import ScoreCardList from './ScoreCardList';

export default ScoreCardList;
